module.exports = __webpack_public_path__ + "static/3-b3dc5f23d9a817e8304b45aa2f7fb1ad.jpeg";